<se-fe-layout #layout>
  <div seFeLayoutGlobalNav>
    <h1 class="title">
      <se-fe-icon-button class="app-menu-toggle" (click)="layout.toggleLeftNav()">
        <se-fe-icon seFeDataName="menu" seFeDataSize="700"></se-fe-icon>
      </se-fe-icon-button>
      People and Orgs UI Library
    </h1>
  </div>
  <se-fe-left-nav seFeLayoutLeftNav [seFeDataNavTree]="navTree" [seFeDataFooterLinks]="footerLinks"
    (seFeNavigate)="handleNavigate($event)">
  </se-fe-left-nav>

  <div seFeLayoutPageContent class="page-content-mobile-toggle">
    <router-outlet></router-outlet>
  </div>
</se-fe-layout>
